if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      // Check if sticky
      if (this.dataset.isSticky) {
        const barWrapper = this.closest('.new-announcement-bar__wrapper')
        barWrapper.classList.add('is-sticky')
        // const announcementBarHeight = this.offsetHeight - 1
        const announcementBarHeight = 28
        const mainNav = document.querySelector('.main-nav__wrapper')
        if (mainNav) {
          mainNav.style.top = `${announcementBarHeight}px`
          // Set CSS custom property for main nav to use in calculations
          document.documentElement.style.setProperty(
            '--announcement-bar-height',
            `${announcementBarHeight}px`,
          )
        }
      }
      // Init Swiper
      this.init()

      // Start timers
      this.startTimers()

      // Get all popup links and buttons
      const popupLinks = this.querySelectorAll('span[data-popup-link]')
      const popupButtons = this.querySelectorAll('button.announcement-popup-trigger')

      popupLinks.forEach((link) => {
        link.addEventListener('click', this.openImagePopup.bind(this))
      })

      popupButtons.forEach((button) => {
        button.addEventListener('click', this.openImagePopup.bind(this, button))
      })

      // Get modal image
      this.modal = document.querySelector('image-modal')
    }

    init() {
      const swiperElement = this.querySelector('.js-swiper')
      const duration = swiperElement.dataset.duration ? swiperElement.dataset.duration * 1000 : 5000
      if (!swiperElement) return

      this.swiper = new Swiper(swiperElement, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: duration,
        },
        speed: 600,
      })
    }

    openImagePopup(button) {
      const imageUrl = button.dataset.popupImage
      const url = button.dataset.popupLink
      this.modal.querySelector('.js-image-link').href = url
      this.modal.querySelector('.js-image').src = imageUrl
      this.modal.openImageModal()
    }

    startTimers() {
      const countdownTimers = this.querySelectorAll('.js-countdown-timer')
      countdownTimers.forEach((timer) => {
        const endDate = parseInt(timer.dataset.endDate) * 1000 // Convert seconds to milliseconds

        // Update countdown immediately
        this.updateCountdown(timer, endDate)

        // Update countdown every second
        const intervalId = setInterval(() => {
          this.updateCountdown(timer, endDate, intervalId)
        }, 1000)
      })
    }

    updateCountdown(timer, endDate, intervalId = null) {
      const now = Date.now()
      const diff = Math.max(0, endDate - now) // Ensure diff is never negative

      if (diff === 0) {
        // Countdown has expired
        timer.style.display = 'none'
        if (intervalId) {
          clearInterval(intervalId)
        }
        return
      }

      const hours = Math.floor(diff / 3600000)
      const minutes = Math.floor((diff % 3600000) / 60000)
      const seconds = Math.floor((diff % 60000) / 1000)
      timer.querySelector('.js-countdown-placeholder').textContent =
        `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    }
  }
  customElements.define('announcement-bar', AnnouncementBar)
}

if (!customElements.get('image-modal')) {
  class ImageModal extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.closeBtn = this.querySelector('.js-close-button')
      this.closeBtn.addEventListener('click', this.closeImageModal.bind(this))

      // Add click handler for the backdrop
      this.addEventListener('click', (e) => {
        if (e.target === this) {
          this.closeImageModal()
        }
      })
      this.imageLink = this.querySelector('.js-image-link')
      this.imageLink.addEventListener('click', (e) => this.handleImageLinkClick(e))
    }

    disconnectedCallback() {
      this.closeBtn.removeEventListener('click', this.closeImageModal.bind(this))
      this.imageLink.removeEventListener('click', (e) => this.handleImageLinkClick(e))
    }

    handleImageLinkClick(e) {
      e.preventDefault()
      if (this.imageLink.dataset.closePopup === 'true') {
        this.closeImageModal()
      } else {
        window.open(this.imageLink.href, '_self')
      }
    }

    openImageModal() {
      this.style.pointerEvents = 'auto'
      this.style.display = 'block'
      this.style.opacity = 1
      document.body.classList.add('overflow-hidden')
    }

    closeImageModal() {
      this.style.pointerEvents = 'none'
      this.style.display = 'none'
      this.style.opacity = 0
      document.body.classList.remove('overflow-hidden')
    }
  }
  customElements.define('image-modal', ImageModal)
}
